module.exports = __webpack_public_path__ + "static/img/about1_3.d4bb9d3e.jpg";